import { render, staticRenderFns } from "./pdfView.vue?vue&type=template&id=675bd04a&scoped=true"
import script from "./pdfView.vue?vue&type=script&lang=js"
export * from "./pdfView.vue?vue&type=script&lang=js"
import style0 from "./pdfView.vue?vue&type=style&index=0&id=675bd04a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675bd04a",
  null
  
)

export default component.exports